import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
} from "../common/StyledComponents/StyledFields";
import { Close } from "@mui/icons-material";
import commonStyles from "../../App.module.scss";

interface confirmPaymentCancelDialogProps {
  isOpen: boolean;
  handleClose: () => void;
  handleCancel: () => void;
}

const PaymentCancelConfirmationDialog = (
  props: confirmPaymentCancelDialogProps
) => {
  const { isOpen, handleClose, handleCancel } = props;
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          height: "calc(100% - 128px)",
          width: "calc(100% - 128px)",
          margin: "64px",
          maxWidth: "504px",
          maxHeight: "180px",
          overflowY: "hidden",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
        },
      }}
    >
      <div onClick={handleClose}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 1,
            top: 2,
            color: (theme: any) => theme.palette.grey[500],
          }}
        >
          <Close sx={{ color: "white" }} />
        </IconButton>
      </div>
      <DialogTitle className={commonStyles.dialogTitle}>
        {"Please Confirm"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          className={commonStyles.dialogContext}
        >
          Are you sure want to cancel the payment?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <CommonOutlinedButton onClick={handleClose} id="no">No</CommonOutlinedButton>
        <CommonButton onClick={handleCancel} id="yes">Yes</CommonButton>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentCancelConfirmationDialog;
